import { Button, Container, Flex, ScrollArea, Spinner, Table, Text } from "@radix-ui/themes";
import useFetch from "../../core/hooks/useFetch";
import { ReactNode, useEffect, useMemo, useRef, useState } from "react";
import {IProgrammMinfin} from '../../core/types/services-types/programms-minfin'
import ProgrammMinfinService from '../../core/services/ProgrammMinfinService'
import { toast, ToastContainer } from "react-toastify";
import TransactionService from "../../core/services/TransactionService";
import { GetAllTransactionsFormRequest, ITransaction } from "../../core/types/services-types/transaction-types";
import FilterTransactionsForm from "../../components/controls/forms/filter-transactions-form";
import { ArrowTopRightIcon, MixerVerticalIcon } from "@radix-ui/react-icons";
import { form_to_json } from "../../utils";
import AppTable from "../../components/controls/tables/AppTable";
import Pagination from "../../components/common/renders/pagination-render";
import moment from "moment";
import { Link } from "react-router";
export default function ProgrammsMinfin() {
      const transactionsHeadersTableFormat = useMemo<(string | ReactNode)[]>(() => {
        return [
            "ID",
            "Внешний ID",
            "Отправитель",
            "Тип",
            "Валюта",
            "Комиссия",
            "Количество",
            "Куда",
            "Статус",
            "Сообщение",
            "Тип отправителя",
            "Разделенный платеж",
            "ID Состава Субъекта права",
            "Создано",
            "Обновлено",
            "Действия"
        ]}, [])
    const [programmsMinfin, setProgrammsMinfin] = useState<IProgrammMinfin[]>([])
    const [transactions, setTransactions] = useState<ITransaction[]>([])
    const [totalCount, setTotalCount] = useState<number>(0)
    const [limit, setLimit] = useState(100)
    const [page, setPage] = useState(0)
    const refFormFilters = useRef<HTMLFormElement | null>(null)
    const [fetchMinfinProgramms, isLoadingMinfinProgramms, errorMinfinProgramms, errorsMinfinProgramms] = useFetch(async () => {
        const data = await ProgrammMinfinService.GetAll()
        setProgrammsMinfin(data)
    })

    const [fetchAllTransactionsMinfin, isLoadingFetchAllTransactionsMinfin, errorFetchAllTransactionsminfin, errorsAllTransactionsMinfin] = useFetch(async (form: FormData) => {
        const jsonForm = form_to_json<GetAllTransactionsFormRequest>(form)
        console.log(jsonForm)
        const data = await TransactionService.GetAllMinfin(jsonForm.search, jsonForm.minAmount, jsonForm.maxAmount, jsonForm.currency, jsonForm.dateSort, limit, page)
        setTransactions(data.data)
        setTotalCount(data.count)
    })

     const onSubmitFilters = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        console.log(refFormFilters.current)
        if (refFormFilters.current) {
            const form = new FormData(refFormFilters.current)
            await fetchAllTransactionsMinfin(form)
        }
    }

    const changeActiveIndex = (page: number) => {
        setPage(page)
    }

    const transactionsTableFormat = useMemo(() => {
    return transactions.map(item => {
        const filterItem = {
            ...item,
            user_id: item.sender.login,
            sender: '',
            receiver: '',
            to: item.receiver?.login ?? ''
        }

        const actions = [
            "Действия",
            <Flex gap={'3'} key={item.id}>
                <Link to={`/transaction/${item.id}`}>
                    <Button variant='surface'>
                        <ArrowTopRightIcon />
                    </Button>
                </Link>
            </Flex>
        ]

        return Object.entries(filterItem).concat([actions])
    })
}, [transactions])

      const renderOption = (key: string, value: any) => {
            if(key === 'status') {
                if(value === 'created') {
                    return ( 
                    <Table.Cell>
                       <Text color='orange'> Создана </Text>
                        </Table.Cell>
                    )
                }
                if(value === 'success') {
                    return (
                        <Table.Cell>
                       <Text color="grass"> Подтверждена </Text>
                        </Table.Cell>
                    
                    )
                }
            }
            if(key === 'splitted') {
                if(value === true) {
                    return (
                       <Table.Cell>
                       <Text color="grass"> Да </Text>
                        </Table.Cell>
                    )
                }
                else {
                    return (
                        <Table.Cell>
                       <Text color="grass"> Нет </Text>
                        </Table.Cell>
                    )
                }
            }
            if(key === 'createdAt' || key === 'updatedAt') {
               return ( 
                <Table.Cell>
               { moment(value).format("DD.MM.YYYY HH:mm")}
                </Table.Cell>
               )
            }
            if(key === 'message') {
                if(value) {
                return (
                     <Table.Cell>
               {value.substring(0, 40)}...
                </Table.Cell>
                )
            }
            }
            return <Table.Cell>{value}</Table.Cell>
        }


    useEffect(() => {
        fetchMinfinProgramms()
    }, [])

    useEffect(() => {
        if(refFormFilters.current) {
        fetchAllTransactionsMinfin(new FormData(refFormFilters.current))
        }
    }, [limit, page])
    useEffect(() => {
        if (errorMinfinProgramms) toast.error(errorMinfinProgramms)
    }, [errorMinfinProgramms])
    return (
        <Container className="md:p-5 pt-5 bg-zinc-100 min-h-[100vh]">
             <ToastContainer
              position="top-center"
              />
            <Container className="bg-zinc-50 rounded-lg shadow-lg p-10 mb-5"> 
                <Text weight={'bold'} size={'6'}>Программы Министерства Финансов СССР</Text>
            </Container>
             <Container className="bg-zinc-50 rounded-lg shadow-lg p-10 mb-20"> 
                {isLoadingMinfinProgramms ? <Spinner /> : programmsMinfin.map(item => {
                    return (
                        <Flex key={item.id} align={'center'} wrap={'wrap'} gap={'5'} className="mb-5">
                            <Text weight={'bold'} size={'3'}>
                                {item.id}.{item.name}
                            </Text>
                            <Text weight={'bold'} size={'3'} color="grass">
                                {item.balance}
                            </Text>
                        </Flex>
                    )
                })}
            </Container>
            <Container className="bg-zinc-50 rounded-lg shadow-lg p-10 mb-5"> 
                <Text weight={'bold'} size={'6'}>Транзакции</Text>
                <Flex className="filters">
                    <form ref={refFormFilters} onSubmit={onSubmitFilters}>
                        <FilterTransactionsForm 
                        search
                        min
                        max
                        currency
                        sortDate

                        />
                        <Button>
                            <MixerVerticalIcon />
                            Применить фильтры
                        </Button>
                    </form>
                </Flex>
            </Container>
            <Container className="bg-zinc-50 rounded-lg shadow-lg p-10 mb-5"> 
           <ScrollArea type="always" scrollbars="both" style={{ height: 650 }} >
            {
            isLoadingFetchAllTransactionsMinfin ? 
            "Загрузка..."
                :
                <AppTable
                headers={transactionsHeadersTableFormat} 
                data={transactionsTableFormat}
                renderOption={renderOption}
                />
            }
           
           </ScrollArea>
           <Container className="p-2"> 
           <Pagination
           total={totalCount} 
           count={limit} 
           activeIndex={page}
           onChangeIndex={changeActiveIndex}
           />
           </Container>
            </Container>
        </Container>
    )
}